import Rand from "rand-seed";

export namespace Random {
  let rand = new Rand("abc");
  let stack = [] as Rand[];

  export function push() {
    stack.push(rand);
    rand = new Rand(rand.next().toString());
  }

  export function pop() {
    const prev = stack.pop();
    if (prev) {
      rand = prev;
    }
  }

  export function seed(value: string | Number) {
    rand = new Rand(String(value));
  }

  export function int(min: number, max: number) {
    return Math.ceil(min) + Math.floor(rand.next() * (max - min));
  }

  export function from<T>(values: T[]): T {
    return values[Math.floor(rand.next() * values.length)];
  }

  export function value(min = 0, max = 1) {
    return min + rand.next() * (max - min);
  }

  export function shuffled<T>(values: T[]): T[] {
    const items = values.map((item) => {
      return {
        item,
        score: value(),
      };
    });

    return items.sort((a, b) => a.score - b.score).map(({ item }) => item);
  }
}

export namespace Mathf {
  export function lerp(min: number, max: number, value: number) {
    return min + (max - min) * value;
  }

  export function map(
    value: number,
    inMin: number,
    inMax: number,
    outMin: number,
    outMax: number
  ) {
    return outMin + ((value - inMin) / (inMax - inMin)) * (outMax - outMin);
  }
}
